<template>
  <div>
    <div class="container">
      <e-search
        :data="filterInfoCR.data"
        :field-list="filterInfoCR.filterList"
        @handleFilter="handleQuery"
        @handleReset="handleReset"
        @handleSuggestions="handleSuggestions"
        @handleFocus="handleFocus"
        @handleInput="handleInput"
        @handleEvent="handleEvent"
        @handleSelect="handleSelect"
      ></e-search>
    </div>

    <div class="container">
      <eTableList
        :table-data="tableData"
        :table-label="tableLabelCR"
        :row-key="rowKey"
        style="margin-top: 10px"
      >
        <template #indexSlot="slot">
          <div class="flex-center-center">{{ slot.scope.$index + 1 }}</div>
        </template>

        <template #roleList="slot">
          <div
            v-if="slot.scope.row.roleList.length > 1"
            style="color: #2587ff; cursor: pointer"
          >
            <eui-btn
              type="link"
              size="12"
              @click="viewRole(slot.scope.row.roleList)"
              >共计{{ slot.scope.row.roleList.length }}个角色</eui-btn
            >
          </div>
          <div v-else>{{ slot.scope.row.roleList[0].roleName }}</div>
        </template>
        <template #statusSlot="slot">
          <span v-if="slot.scope.row.status === 3"
            >审批拒绝
            <el-tooltip effect="dark" placement="top">
              <div slot="content">
                {{
                  slot.scope.row.opinion
                    ? slot.scope.row.opinion
                    : '暂无详细信息'
                }}
              </div>
              <span
                v-if="
                  slot.scope.row.opinion !== '' &&
                  slot.scope.row.opinion !== undefined
                "
                class="return-icon"
              >
                i
              </span>
            </el-tooltip>
          </span>
          <span v-if="slot.scope.row.status === 2"> 审批通过 </span>
          <span v-if="slot.scope.row.status === 1"> 待审批 </span>
        </template>
      </eTableList>
      <div class="pagination">
        <el-pagination
          :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="productTagPage.pageStart"
          :page-size="productTagPage.pageSize"
          :total="productTagPage.pageTotal"
          prev-text="上一页"
          next-text="下一页"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
    <ViewDialog
      :table-list="tableList"
      :visible="viewRoleDialogShow"
      @close="closeCheckRole"
    ></ViewDialog>
  </div>
</template>

<script>
import eTableList from '@/modules/projectA/components/common/e-table-list';
import _ from 'lodash';
import ViewDialog from './components/viewRoleDialog.vue';
import Api from '../../api/authority';
import { roleApply } from './roleApply';
import eSearch from '../../components/common/e-search';

export default {
  name: 'RoleApplyCheckRecord',
  components: {
    ViewDialog,
    eTableList,
    eSearch,
  },
  props: {},
  data() {
    return {
      roleApply,
      query: {
        roleName: null,
        createByName: null,
        memberName: null,
        operationMemberName: null,
      },
      filterInfoCR: roleApply.filterInfoCR,
      tableData: [],
      tableLabelCR: roleApply.tableLabelCR,
      productTagPage: {
        pageStart: 1,
        pageSize: 10,
        pageTotal: 0,
      },
      roleData: {},
      rowKey: 'roleId',
      selectionData: [],
      tableList: [],
      viewRoleDialogShow: false,
      category: {},
      labelName: '',
      titleName: '',
      cloneTableData: [],
      roleList: [],
    };
  },
  computed: {},
  created() {
    this.getList();
  },
  methods: {
    handleEvent(ev) {
      this.category = ev;
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    handleFocus(row) {
      this.labelName = row.item.label;
      this.titleName = row.item.value;
    },
    handleInput(row) {
      if (row === '') {
        this.seekFlag = false;
        this.tableData = [...this.cloneTableData];
      }
    },
    // 去重
    deWeightThree(arr) {
      const map = new Map();
      // eslint-disable-next-line no-restricted-syntax
      for (const item of arr) {
        if (!map.has(item.value)) {
          map.set(item.value, item);
        }
      }
      return [...map.values()];
    },
    // 搜索提示框
    handleSuggestions(val) {
      const { queryString, cb } = val;
      this.roleList = [];
      if (this.tableData?.length > 0 && this.tableData !== undefined) {
        // eslint-disable-next-line no-restricted-syntax
        for (const i of this.tableData) {
          // eslint-disable-next-line no-restricted-syntax
          for (const j of i.roleList) {
            // eslint-disable-next-line no-restricted-syntax
            for (const k in j) {
              if (k === 'roleName') {
                const obj = {
                  value: j.roleName,
                };
                this.roleList.push(obj);
              }
            }
          }
        }
      }
      if (this.labelName === '包含角色') {
        const results1 = queryString
          ? this.roleList.filter(this.createFilter(queryString))
          : this.roleList;
        cb(this.deWeightThree(results1));
      }
    },
    handleSelect(ev) {
      // 只有选择的才能搜索
      this.currentPage = 1;
      this.seekFlag = true;
      if (this.labelName === '包含角色') {
        const arr1 = [];
        // eslint-disable-next-line array-callback-return
        this.cloneTableData.map((item) => {
          // eslint-disable-next-line array-callback-return
          item.roleList.map((ktem) => {
            if (ktem.roleName === ev.value) {
              arr1.push(item);
            }
          });
        });
        this.tableData = arr1;
        // this.handleQuery({ roleList: ev.value });
      }
    },
    viewRole(roleList) {
      this.queryByRoleIdList(roleList);
    },
    queryByRoleIdList(roleList) {
      const params = {
        roleIdList: roleList.map((item) => item.roleId),
      };
      Api.queryByRoleIdList(params).then((res) => {
        if (res.code === '200') {
          this.tableList = res.data;
          this.viewRoleDialogShow = true;
        }
      });
    },
    closeCheckRole() {
      this.viewRoleDialogShow = false;
    },
    handleSelectionChange(val) {
      this.selectionData = val;
    },
    // 搜索
    handleQuery(val) {
      this.query = val;
      if (val.roleList) {
        this.query.roleName = val.roleList;
      }
      this.productTagPage.pageStart = 1;
      this.productTagPage.pageSize = 10;
      this.productTagPage.pageTotal = 0;
      this.getList();
    },
    // 重置
    handleReset() {
      this.query = {
        roleName: null,
        createByName: null,
        memberName: null,
        operationMemberName: null,
      };
      this.productTagPage.pageStart = 1;
      this.productTagPage.pageSize = 10;
      this.productTagPage.pageTotal = 0;
      this.getList();
    },
    // 获得列表
    getList() {
      const params = this.query;
      delete params.roleList;
      // params.companyId = JSON.parse(localStorage.getItem('USERINFO')).companyId;
      params.pageSize = this.productTagPage.pageSize;
      params.pageStart = this.productTagPage.pageStart;
      delete params.roleList;
      Api.approveLogPage(params).then((res) => {
        this.tableData = res.data?.list;
        this.cloneTableData = _.cloneDeep(this.tableData);
        this.productTagPage.pageTotal = res.data.total;
      });
    },
    // 更改页码
    handleCurrentChange(val) {
      this.productTagPage.pageStart = val;
      this.getList();
    },

    // 更改条数
    handleSizeChange(val) {
      this.productTagPage.pageStart = 1;
      this.productTagPage.pageSize = val;
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  .return-icon {
    width: 16px;
    height: 16px;
    display: inline-block;
    border: 1.6px solid rgba(197, 197, 197, 1);
    line-height: 15px;
    text-align: center;
    border-radius: 100%;
    color: rgba(197, 197, 197, 1);
    margin-left: 5px;
    &:hover {
      background: rgba(197, 197, 197, 1);
      color: #fff;
    }
  }
  .button-box {
    padding-bottom: 10px;
    margin-top: 10px;
  }
}
</style>
